import { Injectable } from '@angular/core';
import { CoordinateMapContext } from './models/coordinate-map-context.model';

@Injectable({ providedIn: 'root' })
export class CoordinateMapContextService {
  private context: CoordinateMapContext | null = null;

  register(context: CoordinateMapContext): void {
    this.context = context;
  }

  unregister(): void {
    this.context = null;
  }

  getContext(): CoordinateMapContext | null {
    return this.context;
  }

  resolve(
    mapPredictions?: { getMap(): google.maps.Map | null },
    advancedMapPredictions?: { getMap(): google.maps.Map | null }
  ): CoordinateMapContext {
    if (this.context) {
      return this.context;
    }
    return {
      showMvtMap: false,
      googleMap:
        mapPredictions?.getMap?.() ??
        advancedMapPredictions?.getMap?.() ??
        null,
    };
  }
}
